import { type UUID } from '~/types/common';

import { type ExecutionLogFilters } from './types';

/**
 * Query key factory for data subscription-related queries.
 */
export const queryKeysDataSubscription = {
  base: () => 'dataSubscription' as const,
  executionLog: () =>
    [queryKeysDataSubscription.base(), 'executionLog'] as const,
  getAllContactPoints: (initContactPoint?: boolean) =>
    [
      queryKeysDataSubscription.base(),
      'contactPointsList',
      { initContactPoint },
    ] as const,
  getAllDataSubscription: (initDataSubscription?: boolean) =>
    [
      queryKeysDataSubscription.base(),
      'dataSubscriptionsList',
      { initDataSubscription },
    ] as const,
  getAllNotificationPolicies: (initNotificationPolicies?: boolean) =>
    [
      queryKeysDataSubscription.base(),
      'notificationPoliciesList',
      { initNotificationPolicies },
    ] as const,
  getExecutionLog: (filters?: ExecutionLogFilters) =>
    [...queryKeysDataSubscription.executionLog(), { filters }] as const,
  getExecutionLogDetail: (logId: UUID) =>
    [...queryKeysDataSubscription.executionLog(), 'detail', { logId }] as const,
} as const;
